import React, { useEffect, useContext } from 'react';
import Header from '../components/Header';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Clients from '../components/Clients';
import { LanguageContext } from '../Context/LanguageContext';

function About() {
  const { language } = useContext(LanguageContext);

  const aboutData = {
    en: {
      title: "About Devora",
      subtitle: "Your Trusted Technology Partner",
      description: "Devora is a leading software company offering innovative and reliable digital solutions to empower businesses worldwide.",
      mission: { title: "Our Mission", description: "To empower businesses with smart, scalable, and tailored digital solutions." },
      vision: { title: "Our Vision", description: "To become the global reference in digital transformation services." },
      valuesTitle: "Our Core Values",
      values: [
        { title: "Innovation", description: "We embrace change and constantly look for new ideas." },
        { title: "Quality", description: "We deliver excellence in every line of code." },
        { title: "Integrity", description: "We are honest, ethical, and transparent." },
        { title: "Teamwork", description: "We grow together and celebrate success as one team." }
      ],
      teamTitle: "Our Leadership Team",
      clientsTitle: "Proudly Trusted By"
    },
    ar: {
      title: "عن ديفورا",
      subtitle: "شريكك الموثوق في التكنولوجيا",
      description: "ديفورا هي شركة برمجيات رائدة تقدم حلول رقمية مبتكرة وموثوقة لتمكين الأعمال في جميع أنحاء العالم.",
      mission: { title: "مهمتنا", description: "تمكين الأعمال بحلول ذكية وقابلة للتطوير ومخصصة." },
      vision: { title: "رؤيتنا", description: "أن نصبح المرجع العالمي في خدمات التحول الرقمي." },
      valuesTitle: "قيمنا الأساسية",
      values: [
        { title: "الابتكار", description: "نرحب بالتغيير ونبحث دائمًا عن أفكار جديدة." },
        { title: "الجودة", description: "نقدم التميز في كل سطر من الكود." },
        { title: "النزاهة", description: "نتمتع بالشفافية والأخلاق العالية." },
        { title: "العمل الجماعي", description: "ننمو معًا ونحتفل بالنجاح كفريق." }
      ],
      teamTitle: "فريق القيادة",
      clientsTitle: "نفتخر بثقة شركائنا"
    }
  };

  const content = aboutData[language];

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="about-page bg-light" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <Header
        title={content.title}
        subtitle={content.subtitle}
        background_img="/assets/images/bg3.jpg"
      />

      <section className="py-5">
        <div className="container text-center" data-aos="fade-up">
          <h2 className="fw-bold text-secondary">{content.subtitle}</h2>
          <p className="lead text-muted mt-3">{content.description}</p>
        </div>
      </section>

      <section className="py-5 ">
        <div className="container">
          <div className="row g-4">
            {[content.mission, content.vision].map((item, i) => (
              <div className="col-md-6" data-aos="zoom-in" key={i}>
                <div className="p-4 rounded shadow-sm h-100 bg-light">
                  <h4 className="fw-bold text-secondary mb-3">{item.title}</h4>
                  <p className="text-muted mb-0">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5 ">
        <div className="container text-center">
          <h2 className="fw-bold text-secondary mb-4" data-aos="fade-up">{content.valuesTitle}</h2>
          <div className="row g-4">
            {content.values.map((val, idx) => (
              <div className="col-md-6 col-lg-3" key={idx} data-aos="flip-left" data-aos-delay={idx * 100}>
                <div className="p-4 rounded shadow-sm bg-white h-100">
                  <h5 className="text-secondary fw-bold">{val.title}</h5>
                  <p className="text-muted small">{val.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5 ">
        <div className="container">
          <h2 className="fw-bold text-center text-secondary mb-4" data-aos="fade-up">{content.clientsTitle}</h2>
          <Clients />
        </div>
      </section>

      <section className="py-5 ">
        <div className="container">
          <h2 className="fw-bold text-center text-secondary mb-4" data-aos="fade-up">{content.teamTitle}</h2>
          <Swiper
            spaceBetween={30}
            slidesPerView={4}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            data-aos="fade-up"
          >
            {[...Array(6)].map((_, i) => (
              <SwiperSlide key={i}>
                <div className="text-center p-3 shadow-sm bg-white rounded h-100">
                  <img
                    src="/assets/images/logo1.png"
                    alt={`Team Member ${i + 1}`}
                    className="rounded-circle mb-3"
                    style={{ width: '140px', height: '140px', objectFit: 'cover', border: '3px solid #007bff' }}
                  />
                  <h5 className="fw-bold text-muted">John Doe {i + 1}</h5>
                  <p className="text-muted small">CEO</p>
                  <div className="d-flex justify-content-center gap-3 mt-2">
                    {["facebook", "linkedin", "github"].map((social, sIdx) => (
                      <a key={sIdx} href="#" className="text-primary fs-5">
                        <i className={`fa-brands fa-${social}`}></i>
                      </a>
                    ))}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </div>
  );
}

export default About;
